module.exports = __webpack_public_path__ + "img/service.aabef4c0.jpg";